import { defineMessages } from 'react-intl';

export default defineMessages({
  title_SiteMap: {
    id: 'SiteMap.title',
  },
  auto_title: {
    id: 'auto.title',
  },
  auto_home: {
    id: 'auto.home',
  },
  auto_sinisters: {
    id: 'auto.sinisters',
  },
  auto_contracts_and_guarantees: {
    id: 'auto.contracts_and_guarantees',
  },
  auto_services: {
    id: 'auto.services',
  },
  auto_checkAuto: {
    id: 'auto.checkAuto',
  },
  auto_garage: {
    id: 'auto.garage',
  },
  auto_contact_agent: {
    id: 'auto.contact.agent',
  },
  habitation_title: {
    id: 'habitation.title',
  },
  habitation_home: {
    id: 'habitation.home',
  },
  habitation_sinistre: {
    id: 'habitation.sinistre',
  },
  habitation_contracts_and_guarantees: {
    id: 'habitation.contracts.and.guarantees',
  },
  habitation_contact_agent: {
    id: 'habitation.contact.agent',
  },
  saving_title: {
    id: 'saving.title',
  },
  saving_home: {
    id: 'saving.home',
  },
  saving_contracts: {
    id: 'saving.contracts',
  },
  saving_situation: {
    id: 'saving.situation',
  },
  others_title: {
    id: 'others.title',
  },
  others_faq: {
    id: 'others.faq',
  },
  others_contact: {
    id: 'others.contact',
  },
  others_contact_utils: {
    id: 'others.contact.utils',
  },
  others_offers_and_tips: {
    id: 'others.offers.and.tips',
  },
  others_services: {
    id: 'others.services',
  },
  others_cgu: {
    id: 'others.cgu',
  },
  others_legal_mentions: {
    id: 'others.legal.mentions',
  },
  others_lexique: {
    id: 'others.lexique',
  },
  others_cookies: {
    id: 'others.cookies',
  },
  agent: {
    id: 'agent.title',
  },
});
